import { Outlet } from "react-router-dom";
import AppShell from "@/components/shell/app-shell";
import { DEVELOPER_NAV_SECTIONS } from "@/lib/constants";
import { visibleNavSections } from "@/lib/nav-sections";

export function DeveloperLayout() {
  return (
    <AppShell navSections={visibleNavSections(DEVELOPER_NAV_SECTIONS)}>
      <Outlet />
    </AppShell>
  );
}
